import { i18nTranslationHelper } from '@/i18n'
import {
  makeSkillWebMyProfileRedirectUrl,
  makeSkillWebMyProfileRefundsRedirectUrl
} from '@/main/factories/http'
import PathConstants from '@/main/routes/path-contants'

export default function getUserDataPaths(): PathConstants.RoutesProps {
  const t = i18nTranslationHelper.getTPage

  return {
    USER_PROFILE: {
      value: '/user/profile',
      name: 'user_profile',
      title: t('userProfile.pageTitle')
    },
    USER_INSTEREST_AREAS_SKILLS: {
      value: '/user/interest-areas-skills',
      name: 'user_interest_areas_skills',
      title: t('userInterestAreasSkills.pageTitle')
    },
    USER_SETTINGS: {
      value: '/user/settings',
      name: 'user_settings',
      title: t('userSettings.pageTitle')
    },
    USER_ENROLLMENTS: {
      value: makeSkillWebMyProfileRedirectUrl(),
      name: 'monolith_user_profile',
      title: t('userEnrollments.pageTitle')
    },
    USER_ENROLLMENTS_REFUNDS: {
      value: makeSkillWebMyProfileRefundsRedirectUrl(),
      name: 'monolith_user_profile_refunds',
      title: t('userEnrollments.pageTitle')
    },
    USER_SPACE: {
      value: '/user/space',
      name: 'user_space',
      title: t('userSpace.pageTitle')
    },
    USER_ENROLLMENTS_V2: {
      value: '/user/enrollments',
      name: 'user_enrollments',
      title: t('userEnrollments.pageTitle')
    },
    USER_ENROLLMENT_DETAIL: {
      value: '/user/enrollments/:enrollmentId',
      name: 'user_enrollment_detail',
      title: t('userEnrollmentDetail.pageTitle'),
      computeValue: ({ enrollmentId }) => `/user/enrollments/${enrollmentId}`,
      computeTitle: ({ enrollmentId }) => `${t('userEnrollmentDetail.pageTitle')}${enrollmentId}`
    },
    FAVORITES: {
      value: '/user/favorites',
      name: 'favorites',
      title: t('favorites.pageTitle')
    }
  }
}
